// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
enum Requirements {
    REQUIRED = 0,
    OPTIONAL = 1,
}
export default Requirements;
